<template>
  <div class="tour curated-tour my-personalized-tour" role="presentation">
    <header-mobile>
      <h3>{{ $t('message.personalizedTour') }}</h3>
    </header-mobile>
    <main class="content" aria-label="Main content">
      <div
        class="description"
        v-if="description"
        v-html="$tr(description)"
        role="presentation"
      />
      <div
        v-else
        class="description"
        role="presentation"
      >
        <p>{{ $t("personalizedTour.createText1") }}<br/> {{ $t("personalizedTour.createText2") }}</p>
      </div>
      <div class="poi-counter" role="presentation">
        <span>{{ $t("personalizedTour.poiSelected") }}: {{ counter }}</span>
        <router-link
          :to="{name: 'PersonalizedTour'}"
          tag="a"
          class="btn btn-primary main-background secondary-text"
        >
          {{ $t("personalizedTour.createTour") }}
        </router-link>
      </div>
      <div class="poi-categories" role="presentation">
        <button v-if="tourCategories.length > 0 && tourCategories[0].id !== +category" @click="prevCategory()" class="prev-category"></button>
        <div class="category-name" v-if="currentCategory">{{ $tr(currentCategory.name) }}</div>
        <button v-if="tourCategories.length > 0 && tourCategories[tourCategories.length - 1].id !== +category" @click="nextCategory()" class="next-category"></button>
      </div>
      <poi-list :poiList="poiList(category)" :editMode="true" />
    </main>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import HeaderMobile from '@/components/HeaderMobile'
import PoiList from '@/components/PoiList'

export default {
  name: 'PersonalizedEdit',
  props: {
    category: {
      required: true
    }
  },
  components: {
    'header-mobile': HeaderMobile,
    PoiList
  },
  created () {
    this.startLoad()
    this.getCategories()
    this.getPOIs().then(() => {
      this.setCurrentPoiList(this.poiList(this.category))
    }).finally(() => {
      this.endLoad()
    })
  },
  methods: {
    ...mapActions('personalized', ['getCategories', 'getPOIs']),
    ...mapMutations(['startLoad', 'endLoad']),
    ...mapMutations('poi', ['setCurrentPoiList']),
    nextCategory: function () {
      this.tourCategories.forEach((item, index) => {
        if (item.id === +this.category && index + 1 < this.tourCategories.length) {
          this.$router.push({ name: 'PersonalizedEdit', params: { category: this.tourCategories[index + 1].id } })
        }
      })
    },
    prevCategory: function () {
      this.tourCategories.forEach((item, index) => {
        if (item.id === +this.category && index > 0) {
          this.$router.push({ name: 'PersonalizedEdit', params: { category: this.tourCategories[index - 1].id } })
        }
      })
    },
    setCurrentCategory: function () {
      this.tourCategories.forEach(item => {
        if (item.id === +this.category) {
          this.currentCategory = item.name
        }
      })
    }
  },
  computed: {
    ...mapState({
      description: state => state.college.settings.personalized_tour.edit_tour_page.description
    }),
    ...mapState('personalized', {
      tourCategories: state => state.categoriesList,
      counter: state => state.poiSelected.length
    }),
    ...mapGetters('personalized', {
      poiList: 'getCategoryPOIs',
      getCurrentCategory: 'getCurrentCategory'
    }),
    currentCategory: function () {
      return this.getCurrentCategory(+this.category)
    }
  },
  watch: {
    $route: function (next, prev) {
      this.setCurrentPoiList(this.poiList(this.category))
    }
  }
}
</script>
